import {Button, Card, Popconfirm, Typography} from 'antd';
import {DeleteOutlined, ReadOutlined} from '@ant-design/icons';
import {Book} from "../../../../../shared/types/api";
import {useNavigate} from "react-router-dom";
import * as API_BOOKS from "../../../../../shared/http/books";
import {useState} from "react";
import Constants from "../../../../../const/Constants";

const {Text} = Typography;

const BookCard: React.FC<{ book: Book, deleteBook : (id:number) => void }> = ({book, deleteBook}) => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(false);

    const onDelete = (id: number) => {
        setLoading(true)
        // @ts-ignore
        API_BOOKS.deleteBook(id).then(() => {
            deleteBook(book.id)
        }).finally(()=>{
            setLoading(false)
        });
    }


    const coverSrc = book.coverId ? `${Constants.queryConst}/file/book/cover/image?id=${book.coverId}` : '../images/books/nocover.png'

    return (
        <Card
            title={book.title}
            style={{width: 300, margin: 16}}
            hoverable
            cover={
                <div
                    style={{
                        height: 308,
                        width: 200,
                        overflow: "hidden",
                        paddingTop: 8,
                        margin: "0 auto",
                        borderRadius: 12,
                    }}
                >
                    <img
                        src={coverSrc}
                        alt="Cover"
                        loading="lazy"
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 8
                        }}
                    />
                </div>}
            actions={[
                <Button type="link" onClick={() => navigate(`/books/${book.id}/read`)}
                        icon={<ReadOutlined/>}>Читать</Button>,
                <Popconfirm
                    title="Удалить эту книгу?"
                    onConfirm={() => onDelete(book.id)}
                    okText="Да"
                    cancelText="Нет"
                >

                    <Button loading={loading} type="link" danger icon={<DeleteOutlined/>}>Удалить</Button>
                </Popconfirm>,
            ]}
        >
            <Text><strong>Автор(ы):</strong> {book.authors.join(', ')}</Text><br/>
            <Text><strong>Язык:</strong> {book.language}</Text><br/>
        </Card>
    )
}

export default BookCard
